// import { createHttpLink } from 'apollo-link-http';
import { createUploadLink } from 'apollo-upload-client';
import runtimeConfig from '../../../utils/runtime';

export default () =>
  createUploadLink({
    uri: runtimeConfig.RAZZLE_GRAPHQL_URL || 'http://localhost:8888/graphql',
  });
